<template>
  <div class="vv-valid">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'VvValid'
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.vv-valid {
  border: 3px solid $secondary;
  border-radius: 8px;
  padding: 15px;
  background-color: white;
  box-shadow: 0 14px 28px 5px rgba(220, 220, 220, 0.5);
}
</style>
